import CryptoJS from 'crypto-js'

export default {
    encrypt: function (value) {
        return CryptoJS.AES.encrypt(value.toString(), process.env.CRYPTO_KEY).toString();
    },
    decrypt: function (value) {
        const bytes = CryptoJS.AES.decrypt(value, process.env.CRYPTO_KEY);
        return bytes.toString(CryptoJS.enc.Utf8);
    }
}


// WEBPACK FOOTER //
// ./src/helpers/cipher.js